/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * PIXTA検索結果のサムネイル画像データ
 * @export
 * @interface PixtaThumbnailImage
 */
export interface PixtaThumbnailImage {
    /**
     * サムネイル画像URL
     * @type {string}
     * @memberof PixtaThumbnailImage
     */
    url: string;
    /**
     * サムネイル画像高さ(px)
     * @type {number}
     * @memberof PixtaThumbnailImage
     */
    height: number;
    /**
     * サムネイル画像幅(px)
     * @type {number}
     * @memberof PixtaThumbnailImage
     */
    width: number;
    /**
     * サムネイル画像余白(px)
     * @type {number}
     * @memberof PixtaThumbnailImage
     */
    margin: number;
}

export function PixtaThumbnailImageFromJSON(json: any): PixtaThumbnailImage {
    return PixtaThumbnailImageFromJSONTyped(json, false);
}

export function PixtaThumbnailImageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PixtaThumbnailImage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': json['url'],
        'height': json['height'],
        'width': json['width'],
        'margin': json['margin'],
    };
}

export function PixtaThumbnailImageToJSON(value?: PixtaThumbnailImage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'height': value.height,
        'width': value.width,
        'margin': value.margin,
    };
}

